import { render, staticRenderFns } from "./GameEnd.vue?vue&type=template&id=03c1f4e7&"
import script from "./GameEnd.vue?vue&type=script&lang=js&"
export * from "./GameEnd.vue?vue&type=script&lang=js&"
import style0 from "./GameEnd.vue?vue&type=style&index=0&id=03c1f4e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports